import { render, staticRenderFns } from "./LisenseAdd.vue?vue&type=template&id=008fceda&"
import script from "./LisenseAdd.vue?vue&type=script&lang=js&"
export * from "./LisenseAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports